import { createSlice } from '@reduxjs/toolkit';

import {
  loadInvestmentPassportsList,
  loadInvestmentPassportsItem,
} from './actions';
import { IInvestmentPassportsState } from './interfaces';

export const investmentPassportsSlice = createSlice({
  name: 'investmentPassports',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as IInvestmentPassportsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadInvestmentPassportsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(
      loadInvestmentPassportsItem.fulfilled,
      (state, { payload }) => {
        state.item = payload;
      }
    );
  },
});
